<template>
  <div class="i-radio-buttons" :class="vertical">
    <div class="field-label" v-if="label">
      {{ label }}
    </div>
    <i v-if="labelInformation" class="label-information-header">{{ labelInformation }}</i>
    <div class="radio-options" v-for="option in options" :key="option.value">
      <label :class="{'disabled-label' : option.disabled, 'horizontal-align' : option.tooltip}">
        <template v-if="!option.hideRadio">
          <input
            type="radio"
            :name="name"
            :checked="option.value === value"
            :value="option.value"
            :disabled="option.disabled"
            @input="onInput"
          />
        </template>
        {{ option.label }}
        <i-tooltip
          v-if="option.tooltip"
          :text="option.tooltip"
          theme="dark"
        >
          <template v-slot:tooltip-wrapper>
            <i-generate-image image="icons/info-white.svg"/>
          </template>
        </i-tooltip>
        <div v-if="option.labelInformation" class="label-information-option">
          <i>{{ option.labelInformation }}</i>
        </div>
      </label>
    </div>

    <div class="field-hint" v-if="hint">
      {{ hint }}
    </div>
  </div>
</template>

<script>
import ITooltip from "@/components/common/ITooltip.vue";
import IGenerateImage from "@/components/common/IGenerateImage.vue";

export default {
  name: "IRadioButtons",
  components: {IGenerateImage, ITooltip},
  props: {
    label: {
      type: String
    },
    labelInformation: {
      type: String,
      required: false
    },
    hint: {
      type: String
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean
    },
    vertical: {
      type: String, // horizontal|vertical
    },
    // New prop to hide the radio circle. It's optional and defaults to false.
    hideRadio: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  methods: {
    onInput(e) {
      this.$emit('input', e.target.value);
    },
  }
}
</script>

<style lang="scss">
@import "IRadioButtons";
</style>
